/**
 * API Configuration
 * Centralized configuration for API endpoints and environment-specific settings
 * 
 * Environment variables are set via .env files:
 * - .env.development
 * - .env.staging
 * - .env.production
 */

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://backend.bpgap.creathing.be',
  gtmId: process.env.REACT_APP_GTM_ID || 'GTM-5CPQSLP',
  fingerprintToken: process.env.REACT_APP_FINGERPRINT_TOKEN || 'SKJXjlcBdzJT91HqVey9',
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
};

/**
 * Validate that required environment variables are set
 */
if (!API_CONFIG.baseURL) {
  console.warn('REACT_APP_API_URL is not set, using default value');
}

export default API_CONFIG;
